module.exports = __webpack_public_path__ + "static/img/goodsList-min.6bcf5735.png";